import React from 'react'
import { Card, LazyImage, Heading, HyperButton, Text } from '@offerzen/pinata-shame'

import styles from './styles'

/**
 * @typedef {Object} Cta
 * @property {string} label
 * @property {string} href
 */

/**
 * ErrorCard component
 *
 * @param {Object} props
 * @param {string} props.image
 * @param {string} [props.altText]
 * @param {string} props.heading
 * @param {string} [props.subheading]
 * @param {Cta} props.cta
 *
 * @returns {JSX.Element}
 */
const ErrorCard = ({ image, altText, heading, subheading, cta }) => {
  return (
    <Card className={styles.card}>
      <LazyImage loader={() => import(`../../../assets/${image}`)} alt={altText || ''} width={210} />
      <Heading>
        <strong>{heading}</strong>
      </Heading>

      <If condition={subheading}>
        <Text>
          <p>{subheading}</p>
        </Text>
      </If>

      <HyperButton className={styles.button} label={cta.label} size="medium" href={cta.href} external />
    </Card>
  )
}

export default ErrorCard
